export const MuiAutocomplete = {
  styleOverrides: {
    root: {
      width: '100%',

      '.MuiAutocomplete-listbox': {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      },

      '.MuiAutocomplete-popupIndicatorOpen svg': {
        fill: 'rgba(34, 40, 34, 1)',
      },
    },
    popper: {
      '.MuiAutocomplete-paper': {
        borderRadius: '6px',
      },

      '.MuiAutocomplete-listbox': {
        padding: '7px 0',
        margin: '0 3px',

        '.MuiAutocomplete-option': {
          padding: '8px 13px 8px',
          borderRadius: '6px',

          '&:hover, &.Mui-focused, &[aria-selected="true"].Mui-focused ': {
            background: 'rgba(201, 255, 235, 1)',
          },

          '&[aria-selected="true"]': {
            background: 'none',
          },
        },
      },
    },
  },
};
